// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3bjn6","card":"Cards_card__eGUfZ","workOrder":"Cards_workOrder__3Yu5e","image":"Cards_image__10J_3","worker":"Cards_worker__3neuM"};